let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hlqS1")).then(() => parcelRequire('9wTHj'));